export default __webpack_public_path__ + "static/media/greenCircle.52f5eee6.svg";